import { render, staticRenderFns } from "./OrderListRepairExpand.vue?vue&type=template&id=64c5b188&scoped=true&"
import script from "./OrderListRepairExpand.vue?vue&type=script&lang=js&"
export * from "./OrderListRepairExpand.vue?vue&type=script&lang=js&"
import style0 from "./OrderListRepairExpand.vue?vue&type=style&index=0&id=64c5b188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5b188",
  null
  
)

export default component.exports